import { size } from 'lodash';

export default {
    buttons: {
        start: '开始',
        end: '结束活动',
        submit: '提交',
        next: '下一题',
        result: '查看结果',
        nextModule: '下一个',
        selfDone: '自习完成',
        taskDone: '作业完成',
        moduleStart: '开始活动',
    },
    teacher: {
        setting: '活动设置',
        wayOfProgress: '进行方式',
        wayOfReading: '阅读方式',
        title: '活动标题',
        guide: '活动指南',
        tooltip: `
        <span class="tooltip_list">
            <strong>与老师一起</strong>
            <span>与老师一起逐题进行</span>
         </span>
         <span class="tooltip_list">
            <strong>自主学习</strong>
            <span>学生按照自己的速度完成所有题目</span>
        </span>
        `,
        screen: '活动画面',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `活动内容 <span>${title}</span>`;
            }
            return '活动内容';
        },
        summary: '活动摘要',
        addQuestions: {
            search: {
                empty: '✨ 在搜索框中输入词汇，结果会显示在这里。\n从表格中复制并粘贴数据，可直接添加到下方待添加列表。',
                placeholder: '搜索词汇，或从 Excel / 谷歌表格粘贴',
            },
            wait: {
                empty: {
                    default: '点击 [添加到活动] 时，所有待添加的词汇会一起加入。',
                    choice: '点击 [添加到活动] 时，所有待添加的词汇会一起加入。\n将错误选项留空，注册时会自动从其他词汇中填入。\n表格列顺序为：词汇 / 释义 / 错误 1 / 错误 2 / 错误 3。',
                },
            },
            infoTitle: '搜索您想要的词汇，添加属于自己的题目。',
            infoDesc: {
                default: '从 Excel 或谷歌表格复制粘贴，可一次性添加！',
                choice: '从 Excel 或谷歌表格复制粘贴，可一次性添加，\n错误选项留空时会自动填入！',
            },
            noMeaning: {
                title: '存在没有释义的词汇！',
                message: '有词汇没有释义。<br />要排除这些词汇，只添加其余词汇吗？',
                enterMeaning: '输入释义',
                submitRest: '仅添加其余',
            },
            invalidChar: {
                title: '存在无效字符！',
                message: '释义只能输入韩文、英文、数字以及部分符号。',
                invalidCharsLabel: '输入内容中不允许的字符:',
            },
            registerResult: '添加结果',
        },
    },
    alert: {
        wrong: '哎呀，答错了。请再试一次。',
        chancesExhausted: '哎呀，答错了！来看看正确答案吧。',
        waiting: () => {
            const messages = ['完成了！请稍等一下。', '很好！请稍等一下。', '做得好！请稍等一下。'];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: '题目',
    answerRate: '正确率',
    relation: '{relation} 关系',
    allDone: '所有题目都已完成。请结束活动！',
    champion: '冠军',
    allSelect: '全部选择',
    majorVocabulary: '主要词汇',
    remainingVocabulary: '其他词汇',
    students: {
        errorTooltip: '学生处于离线状态',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `每位学生的${isOngoing ? '状态' : '结果'}`;
            },
        },
        standby: '进行前',
        notAttended: '未参与',
        inProgress: '进行中',
        notCompleted: '未完成',
        completed: '已完成',
    },
    modal: {
        title: '结束活动',
        message: '要结束活动吗？',
    },
    state: {
        correct: '正确',
        wrong: '错误',
    },
    toast: {
        addStarStudent: '已给 {name} 赠送表扬星',
        addAllStar: '已给全体学生（{length}名）赠送表扬星',
        failedStar: '表扬星赠送失败',
        undo: '撤销',
        undoFailed: '撤销表扬星失败',
    },
};
